import React from "react"
import VariantReader from "aldoo-ra/VariantReader"
import LocalUserPreferences from "aldoo-ra/LocalUserPreferences"
import { twMerge } from "tailwind-merge"

const Tabs = ({
  tabs = [],
  value,
  onChange,
  onTabClick,
  variant = "default",
  styleOverrides = {},
  className = "",
  orientation = "horizontal", // horizontal or vertical
  size = "medium", // small, medium, large
  localUserPreferencesKey = null, // Key for storing user preferences
}) => {
  // Get styles from variant
  const variants = VariantReader.useVariant({
    componentName: "Tabs",
    variant,
    styleOverrides,
  })

  const handleTabClick = (tabValue) => {
    if (onTabClick) onTabClick(tabValue)
    if (onChange && tabValue !== value) {
      onChange(tabValue)

      // Save to local user preferences if key is provided
      if (localUserPreferencesKey && localUserPreferencesKey.trim()) {
        try {
          LocalUserPreferences.set(localUserPreferencesKey, tabValue)
        } catch (error) {
          console.warn("Failed to save tab preference:", error)
        }
      }
    }
  }

  const getTabClassName = (tab) => {
    const isActive = tab.value === value
    const isDisabled = tab.disabled

    return twMerge(
      variants.tab,
      isActive ? variants.tabActive : variants.tabInactive,
      isDisabled ? variants.tabDisabled : variants.tabEnabled,
      size === "small" ? variants.tabSmall : "",
      size === "large" ? variants.tabLarge : "",
      tab.className || ""
    )
  }

  return (
    <div
      className={twMerge(
        variants.container,
        orientation === "vertical" ? variants.containerVertical : "",
        className
      )}
      role="tablist"
      aria-orientation={orientation}
    >
      <div
        className={twMerge(
          variants.tabList,
          orientation === "vertical" ? variants.tabListVertical : ""
        )}
      >
        {tabs.map((tab, index) => (
          <button
            key={tab.value || index}
            className={getTabClassName(tab)}
            onClick={() => handleTabClick(tab.value)}
            disabled={tab.disabled}
            role="tab"
            aria-selected={tab.value === value}
            aria-controls={`tabpanel-${tab.value}`}
            id={`tab-${tab.value}`}
            type="button"
          >
            {tab.icon && <span className={variants.tabIcon}>{tab.icon}</span>}
            <span className={variants.tabLabel}>{tab.label}</span>
            {tab.badge && (
              <span className={variants.tabBadge}>{tab.badge}</span>
            )}
          </button>
        ))}
      </div>

    </div>
  )
}

export default Tabs
